import { withRBAC } from "../rbac";
import { ProjectCreate } from "./ProjectCreate";
import { ProjectEdit } from "./ProjectEdit";
import { ProjectList } from "./ProjectList";
import { ProjectShow } from "./ProjectShow";

export const projects = {
  list: withRBAC(ProjectList, "view_all_data"),       // Using a generic view permission or custom
  show: withRBAC(ProjectShow, "view_all_data"),
  create: withRBAC(ProjectCreate, "manage_documents"), // Assuming manage_documents covers projects as per old spec
  edit: withRBAC(ProjectEdit, "manage_documents"),
  recordRepresentation: "name",
};
